import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Users } from "lucide-react";

/** When a lead search runs, also show matching prospects (numbers that are not leads yet). */
export function ProspectHits({ q }) {
  const navigate = useNavigate();
  const [hits, setHits] = useState([]);
  useEffect(() => {
    const t = q.trim();
    if (t.length < 3) { setHits([]); return; }
    let live = true;
    api.get("/prospects", { params: { search: t, page: 1, page_size: 5 } })
      .then(({ data }) => { if (live) setHits(data.items || data || []); }).catch(() => { if (live) setHits([]); });
    return () => { live = false; };
  }, [q]);
  if (!hits.length) return null;
  return (
    <div className="mb-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm" data-testid="prospect-hits">
      <div className="flex items-center gap-1.5 font-semibold text-amber-800"><Users className="w-4 h-4" /> Also found in Prospects ({hits.length}{hits.length === 5 ? "+" : ""})</div>
      <div className="flex flex-wrap gap-2 mt-1.5">
        {hits.map((p) => (
          <button key={p.id} onClick={() => navigate(`/calling-queue?q=${encodeURIComponent(p.mobile)}`)} className="px-2.5 py-1 rounded-full bg-white border border-amber-200 hover:border-amber-500 text-xs" data-testid={`prospect-hit-${p.id}`}>
            <b>{p.name}</b> · {p.mobile} · {p.status}{p.campaign ? ` · ${p.campaign}` : ""}{p.assigned_name ? ` · ${p.assigned_name}` : ""}
          </button>
        ))}
      </div>
    </div>
  );
}
